import { laravel_api } from './index'

interface TOSResponse {
    version_tag: string
    content: string
}

interface TOSRequest {
    version?: string
}

export const extendedApiSlice = laravel_api.injectEndpoints({
    endpoints: (builder) => ({
        getTermsOfService: builder.query<TOSResponse, TOSRequest | undefined>({
            query: (params) => ({
                url: `/api/v2/terms-of-service`,
                params,
                method: 'GET'
            })
        })
    })
})

export const { useGetTermsOfServiceQuery } = extendedApiSlice
